import clsx from 'clsx';
import React from 'react';
import { factory } from '../../../factory/factory.utils.mjs';
import { Box } from '../../../Other/Box/Box.mjs';
import classes from './LevelsGroup.module.css.mjs';

const LevelsGroup = factory((props, ref) => {
  const { className, ...others } = props;
  return /* @__PURE__ */ React.createElement(Box, { ref, className: clsx(className, classes.levelsGroup), ...others });
});

export { LevelsGroup };
